export const Types = {
  GET_LABOUR_REQUEST: 'GET_LABOUR_REQUEST',
  GET_LABOUR_SUCCESS: 'GET_LABOUR_SUCCESS',
  SET_LABOUR_ERROR: 'SET_LABOUR_ERROR',
  SET_LABOUR_SELECTION: 'SET_LABOUR_SELECTION',
  SET_LABOUR_QUAN: 'SET_LABOUR_QUAN',
  SET_LABOUR_FILTER_KEY: 'SET_LABOUR_FILTER_KEY',
  RESET_LABOURS: 'RESET_LABOURS',
  ADD_LABOURS: 'ADD_LABOURS'
};
export const getLabourRequest = (
  kulModelKodu,
  garantiTipi,
  hizmetKodu,
  WorkOrderLabours,
  WorkOrderId
) => ({
  type: Types.GET_LABOUR_REQUEST,
  kulModelKodu,
  garantiTipi,
  hizmetKodu,
  WorkOrderLabours
  ,WorkOrderId
});

export const resetLabours = () => {
  localStorage.setItem("UpdateButtonLabourControl", 0);
  return {
    type: Types.RESET_LABOURS
  }
};

export const getLabourSuccess = (response, selectedlabours) => {
  localStorage.setItem("UpdateButtonLabourControl", 1);
  return {
    type: Types.GET_LABOUR_SUCCESS,
    payload: response,
    selectedlabours
  }
};


export const addLabours = labours => {
  localStorage.setItem("ManualDiscountWorkOrderDirty", "1");
  return { type: Types.ADD_LABOURS, payload: labours };
};


export const setLabourError = error => ({
  type: Types.SET_LABOUR_ERROR,
  payload: { error }
});

export const setLabourSelection = (defect, item) => {
  return {
    type: Types.SET_LABOUR_SELECTION,
    payload: { defect, item }
  };
};

export const setLabourQuan = (labour, value) => {
  return {
    type: Types.SET_LABOUR_QUAN,
    payload: { labour, value }
  };
};

export const setLabourFilterKey = value => {
  return {
    type: Types.SET_LABOUR_FILTER_KEY,
    payload: { value }
  };
};
